import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import * as echarts from 'echarts';
import dayjs from 'dayjs';
export default {
  name: 'device_history_analysis',
  props: {
    current: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '历史分析',
        queryFunName: 'deviceItemLogQuery',
        itemQueryFunName: 'deviceItemQuery',
        dicTreeFunName: 'dictionaryCache'
      },
      searchForm: {
        page: 1,
        limit: -1,
        sortField: '^ts',
        deviceId: this.current.id,
        year: dayjs().format('YYYY')
      },
      dicData: {
        typeUpperCode: 'iot_sensor_item',
        configTypes: [],
        configTypeOptions: {},
        configTypeIdOptions: {}
      },
      item_list: [],
      checked: [],
      count: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$api[this.pageConfig.dicTreeFunName](this.dicData.typeUpperCode).then(function (res) {
      if (res.data) {
        _this.dicData.configTypes = res.data;
        var _iterator = _createForOfIteratorHelper(res.data),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _this.dicData.configTypeOptions[item.code] = item.name;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this.itemQuery();
      }
    });
  } // , watch:{
  //   'searchForm.starDate'
  // }
  ,
  destroyed: function destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    back: function back() {
      this.$emit('child-go-device');
    },
    itemQuery: function itemQuery() {
      var _this2 = this;
      this.$api[this.pageConfig.itemQueryFunName]({
        page: 1,
        limit: 50,
        deviceId: this.current.id
      }).then(function (res) {
        var _iterator2 = _createForOfIteratorHelper(res.data),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            _this2.dicData.configTypeIdOptions[item.id] = _this2.dicData.configTypeOptions[item.type];
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        _this2.item_list = [];
        var _iterator3 = _createForOfIteratorHelper(res.data),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item = _step3.value;
            if (_item.valueType != 'Enums') {
              _this2.item_list.push(_item);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        console.log('this.dicData.configTypeIdOptions', _this2.dicData);
      });
    },
    query: function query() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var loading, res, obj, legend, xAxis, series_obj, createTime, _iterator4, _step4, _item3, key, _iterator5, _step5, item, _key, _iterator6, _step6, _item2, option;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = _this3.$loading({
                lock: true,
                text: '数据加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              if (_this3.timer) {
                clearTimeout(_this3.timer);
              }
              _this3.timer = setTimeout(function () {
                loading.close();
              }, 60000);
              if (_this3.echarts) {
                _this3.echarts.clear();
              }
              _this3.echarts = echarts.init(document.getElementById('chart-container'));
              _context.next = 7;
              return _this3.$api[_this3.pageConfig.queryFunName](_this3.current.id, _this3.searchForm.year, _objectSpread(_objectSpread({}, _this3.searchForm), {}, {
                itemCode: _this3.checked.toString()
              }));
            case 7:
              res = _context.sent;
              if (_this3.timer) {
                clearTimeout(_this3.timer);
              }
              loading.close();
              _this3.count = res.data ? res.data.length : 0;
              obj = {};
              legend = [];
              xAxis = [];
              series_obj = {};
              createTime = '';
              _iterator4 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  _item3 = _step4.value;
                  createTime = _this3.dayjs(_item3.ts).format('YYYY-MM-DD HH:mm:ss');
                  if (!obj[_item3.itemCode]) {
                    legend.push(_item3.itemName);
                    obj[_item3.itemCode] = {
                      label: _item3.itemName,
                      data: [_objectSpread(_objectSpread({}, _item3), {}, {
                        createTime: createTime
                      })]
                    };
                  } else {
                    obj[_item3.itemCode].data.push(_objectSpread(_objectSpread({}, _item3), {}, {
                      createTime: createTime
                    }));
                  }
                  xAxis.push(createTime);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              xAxis = _toConsumableArray(new Set(xAxis));
              // console.log('xAxis',xAxis)
              for (key in obj) {
                obj[key].options = {};
                _iterator5 = _createForOfIteratorHelper(obj[key].data);
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    item = _step5.value;
                    obj[key].options[item.createTime] = item;
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
              }
              // console.log('obj',obj)

              for (_key in obj) {
                series_obj[_key] = {
                  name: obj[_key].label,
                  type: 'line',
                  data: []
                };
                _iterator6 = _createForOfIteratorHelper(xAxis);
                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    _item2 = _step6.value;
                    series_obj[_key].data.push(obj[_key].options[_item2] ? obj[_key].options[_item2].itemValue : '0');
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
              }

              // for(let key in obj){
              //     series.push({
              //         name:obj[key].label,
              //         type:'line',
              //         data:obj[key].data,
              //     })
              // }

              // console.log('series_obj',series_obj)
              console.log('legend1', legend);
              option = {
                color: ['#2788E1', '#DD4588', '#66DC95', '#502CF1', '#E0831A', '#8fd3e8', '#d95850'],
                tooltip: {
                  trigger: 'axis'
                },
                legend: {
                  textStyle: {
                    color: '#000'
                  },
                  data: legend
                },
                grid: {
                  bottom: 80
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  axisLabel: {
                    show: true,
                    rotate: 30,
                    textStyle: {
                      color: '#000'
                    }
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#094060'
                    }
                  },
                  data: xAxis
                },
                yAxis: {
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: '#000'
                    }
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#094060'
                    }
                  },
                  type: 'value'
                },
                series: Object.values(series_obj)
              };
              _this3.echarts.setOption(option);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    search: function search() {
      if (!this.checked.length) {
        this.$message.info('请先选择设备参数');
        return;
      }
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : '^ts';
      this.query();
    }
  }
};